<template>
  <div>
    <a-spin :spinning="isloading" tip="加载中...">
      <div class>
        <div class="pxkeji-right-box" style="margin-top:0">
          <a-form class="ant-advanced-search-form">
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item label="证书名称">
                  <a-input placeholder="请输入" v-model="where.keyword.name" />
                </a-form-item>
              </a-col>
            
              <a-col :span="16" :style="{ textAlign: 'left' }">
                <a-button type="primary" @click="searchList">搜索</a-button>
              </a-col>
            </a-row>
          </a-form>
          <a-table
            :columns="list.columns"
            rowKey="id"
            :pagination="list.pagination"
            @change="onChange"
            :dataSource="list.datas"
            :loading="isloading"
            :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows,getCheckboxProps:getCheckboxProps}"
            :locale="{emptyText:'暂无数据'}"
          >
            <span slot="type" slot-scope="type">
                <span v-if="type==1">专业课</span>
                <span v-else-if="type==2">公需课</span>
              </span>
            <span slot="status" slot-scope="status">
                <a-tag v-if="status==1" color="green">启用</a-tag>
                <a-tag v-else color="red">禁用</a-tag>
              </span>
            <span slot="trigger" slot-scope="trigger">
          <template v-if="trigger.triggerType==0">学分({{trigger.value}})</template>
          <template v-if="trigger.triggerType==1">学时({{trigger.value}})</template>
          <template v-if="trigger.triggerType==2">关联课程</template>
          <template v-if="trigger.triggerType==3">关联考试</template>
        </span>
            
          </a-table>
          <a-button type="primary" :style="{ margin:'10px'}" @click="choseBack">选择并返回</a-button>
        </div>
        
      </div>
    </a-spin>
  </div>
</template>

<script>
var that;
const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "序号"
  },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "证书名称"
  },
  {
    dataIndex: "type",
    key: "type",
    align: "center",
    title: "证书类型",
    scopedSlots: { customRender: "type" }
  },
  {
    dataIndex: "trigger",
    key: "trigger",
    align: "center",
    title: "发证条件",
    scopedSlots: { customRender: "trigger" }
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  },
  {
    dataIndex: "createTime",
    key: "createTime",
    align: "center",
    title: "添加时间"
  },
];
export default {
  props: {
    ids: Array,
  },
  data() {
    return {
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
        }
      },
      allSelectRows: [],
      selectRows: [], //选中项编号
      isloading: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      that=this;
      this.allSelectRows=this.ids?this.ids:[];
      this.GetList();
    });
  },
  methods: {
    getCheckboxProps(record){
        var checked=false;
        for(var i in that.allSelectRows){
          if(that.allSelectRows[i]==record.id){
            checked=true; 
            that.selectRows.push(that.allSelectRows[i].id)
            break;
          }
        }

        return {
          props:{
            defaultChecked:checked,
            disabled:checked
          },
        }
    },
    GetList() {
      this.isloading = true;
      this.clearRows();
      this.$api.certificate
        .getPageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          null,
          this.where.keyword.name,
          1,
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    //table 单选
    onRowChange(selectedRowKeys, selectedRows) {
      this.selectRows = selectedRowKeys;
      for(var i in that.list.datas){
        if(selectedRowKeys.indexOf(that.list.datas[i].id)!=-1){
          //选中
            var find=false;
            for(var sel in that.allSelectRows){
              if(that.allSelectRows[sel]==that.list.datas[i].id){
                find=true;
                break;
              }
            }

            if(!find){
              that.allSelectRows.push(that.list.datas[i].id);
            }
        }else {
          for(var sel in that.allSelectRows){
           if(that.allSelectRows[sel]==that.list.datas[i].id){
              that.allSelectRows.splice(sel,1);
              break;
            }
          }
        }
      }
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      for(var key in this.allSelectRows){
        delete this.allSelectRows[key];
      }
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    //选择并返回
    choseBack() {
      if(this.allSelectRows.length==0){
        this.$message.error("请选择证书");
        return;
      }
    
      this.$emit("callbackMethod", this.allSelectRows.join(","));
    }
  }
};
</script>
<style>
</style>